import { Card, TablePagination } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddDialog } from "../../components/component/modals/AddModal";
import { fetchMenu } from "../../redux/slices/menuSlice";
import { Shadow } from "../../routers";
import Form from "../../sections/menu/MenuForm";
import EnhancedTable from "../../sections/menu/PageTable";
import { headCells } from "../../sections/news/headCells";

export default function Menu() {
  // TODO: hooks
  const dispatch = useDispatch();
  // TODO: useStates
  const [openAdd, setOpenAdd] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 10,
  });
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);

  // TODO: get the data from slice
  const pages = useSelector((state) => state.menu.menu);

  // TODO: fetching the pages
  React.useEffect(() => {
    // TODO: no need of debounce as all data are fetch already
    dispatch(
      fetchMenu({
        limit: pagination.limit,
        page: pagination.page,
      })
    );
  }, [dispatch, refresh, pagination]);
  // TODO: set the rows

  useEffect(() => {
    const data = (pages?.data || [])?.map((page) => ({
      id: page?.id,
      name: page?.name,
      images: page?.images,
      createdDate: moment(page?.createdAt)
        .format("Do MMMM, YYYY")
        .replace(/(\d+)(th|st|nd|rd)/, "$1$2"),
    }));

    setRows(data);
  }, [pages]);

  // TODO: functions
  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      limit: parseInt(event.target.value, 10),
    }));
  };

  // TODO: console.logs
  return (
    <>
      <Shadow>
        <Card color="transparent" shadow={false}>
          <EnhancedTable
            showSearch={false}
            title="Menu"
            headCells={headCells}
            rows={rows}
            showFilter={false}
            setOpenAdd={() => setOpenAdd((prev) => !prev)}
            page={pagination.page}
            rowsPerPage={pagination.limit}
            search={search}
            setSearch={setSearch}
            refresh={refresh}
            setRefresh={setRefresh}
          />

          {/* TODO: pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pages?.meta?.total}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Shadow>

      {/* TODO: add pages */}
      <AddDialog
        maxWidth="lg"
        title={"Add new menu"}
        open={openAdd}
        handleClose={() => setOpenAdd(false)}
      >
        <Form handleClose={() => setOpenAdd(false)} />
      </AddDialog>
    </>
  );
}
